import React from "react";
import { Star, MessageSquare } from "lucide-react";

export default function Testimonials() {
    return (
        <section className="bg-white py-16 sm:py-20">
            <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-8">
                <div className="text-center fade-up">
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-[52px] font-extrabold tracking-[-0.03em]">
                        What homeowners will say
                    </h2>
                    <p className="mt-4 text-sm text-black/60">Client testimonials coming soon.</p>
                </div>

                <div className="mt-10 rounded-[28px] border border-dashed border-black/15 bg-[#FAFAF5] py-14 flex flex-col items-center justify-center text-center px-6">
                    <div className="h-14 w-14 rounded-full bg-white border border-black/10 flex items-center justify-center">
                        <MessageSquare className="h-6 w-6 text-[#7e9a00]" />
                    </div>
                    <div className="mt-4 flex gap-1">
                        {Array.from({ length: 5 }).map((_, i) => (
                            <Star key={i} className="h-4 w-4 text-[#FFB300]" fill="currentColor" />
                        ))}
                    </div>
                    <div className="mt-4 font-display text-2xl font-bold">Client testimonials coming soon.</div>
                    <p className="mt-2 text-sm text-black/55 max-w-md">
                        We&apos;re currently onboarding our first Dubai clients. Real stories from real homeowners will be shared here soon.
                    </p>
                </div>
            </div>
        </section>
    );
}
